import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Row, Col, FormText } from 'reactstrap';
import { isNumber, Translate, translate, ValidatedField, ValidatedForm } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { convertDateTimeFromServer, convertDateTimeToServer, displayDefaultDateTime } from 'app/shared/util/date-utils';
import { mapIdList } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { IEmailing } from 'app/shared/model/emailing.model';
import { getEntity, updateEntity, createEntity, reset } from './emailing.reducer';

export const EmailingUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const emailingEntity = useAppSelector(state => state.emailing.entity);
  const loading = useAppSelector(state => state.emailing.loading);
  const updating = useAppSelector(state => state.emailing.updating);
  const updateSuccess = useAppSelector(state => state.emailing.updateSuccess);

  const handleClose = () => {
    navigate('/emailing' + location.search);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    values.dateCreated = convertDateTimeToServer(values.dateCreated);

    const entity = {
      ...emailingEntity,
      ...values,
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {
          dateCreated: displayDefaultDateTime(),
        }
      : {
          ...emailingEntity,
          dateCreated: convertDateTimeFromServer(emailingEntity.dateCreated),
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="activitiesApp.emailing.home.createOrEditLabel" data-cy="EmailingCreateUpdateHeading">
            <Translate contentKey="activitiesApp.emailing.home.createOrEditLabel">Create or edit a Emailing</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="emailing-id"
                  label={translate('global.field.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('activitiesApp.emailing.dateCreated')}
                id="emailing-dateCreated"
                name="dateCreated"
                data-cy="dateCreated"
                type="datetime-local"
                placeholder="YYYY-MM-DD HH:mm"
              />
              <ValidatedField
                label={translate('activitiesApp.emailing.bookingId')}
                id="emailing-bookingId"
                name="bookingId"
                data-cy="bookingId"
                type="text"
              />
              <ValidatedField
                label={translate('activitiesApp.emailing.content')}
                id="emailing-content"
                name="content"
                data-cy="content"
                type="text"
              />
              <ValidatedField
                label={translate('activitiesApp.emailing.activityId')}
                id="emailing-activityId"
                name="activityId"
                data-cy="activityId"
                type="text"
              />
              <ValidatedField
                label={translate('activitiesApp.emailing.fromAddress')}
                id="emailing-fromAddress"
                name="fromAddress"
                data-cy="fromAddress"
                type="text"
              />
              <ValidatedField
                label={translate('activitiesApp.emailing.toAddress')}
                id="emailing-toAddress"
                name="toAddress"
                data-cy="toAddress"
                type="text"
              />
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/emailing" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default EmailingUpdate;
